import React, { useEffect, useMemo, useState } from 'react';
import Slider from 'react-slick';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import Lightbox from 'react-image-lightbox';
import { BigPlayButton, Player } from 'video-react';
import { useTranslation } from 'react-i18next';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import styles from './MastersPost.module.scss';
import Avatar from '../Comments/Avatar';
import translate_word from "../../utils/translate";
import 'react-image-lightbox/style.css';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { useRouter } from 'next/router';
import PostCommentSlider from '../PostCommenSlider';
import { like_dislike_saga } from '../../store/actions/posts';
import useLongPress from '../../hooks/useLongPress';
import { useDispatch } from 'react-redux';
import CommentsData from '../Comments/CommentsData';
var canUseDOM = !!(
    (typeof window !== 'undefined' &&
        window.document && window.document.createElement)
);
function MastersPost(props) {
    const [toggler, setToggler] = useState(false);
    const [like_dislike, setLikeOrDislike] = useState(null);
    const [isClick, setClick] = useState(false);
    const [productIndex, setProductIndex] = useState(1);
    const [likeCount, setLikeCount]=useState(0);
    const url = canUseDOM ? `${window.location.href}${props.item.id}` : "";
    const [sliderCurrentId, setSliderCurrentId] = useState(0);
    const dispatch = useDispatch();
    const images = useMemo(() => {
        return props.item?.files?.map((el) => el?.file_url);
    }, [props.item.files]);
    const { t, i18n } = useTranslation();
    const router = useRouter();

    const posts_like_dislike = (like_count) => {                
        dispatch(
            like_dislike_saga({ id: props.item.id, token: props.token, cb:()=>{                
                setLikeOrDislike(true);
                setClick(true)
                setLikeCount(likeCount?+likeCount+1:+like_count+1)
            } }),
            
        );
    };
    const onLongPress = () => {
        // if (props.token) {
            posts_like_dislike()
        // }
    };
    const longPressEvent = useLongPress(onLongPress);
    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
        beforeChange: (current, next) => {
            if (next < current) {
                setSliderCurrentId(sliderCurrentId - 1);
            } else if (next !== current) {
                setSliderCurrentId(sliderCurrentId + 1);
            }
        },
        responsive: [
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 1,
                    infinite: false,
                }
            }
        ]
    };
    useEffect(() => {
        if (isClick) {
            const timeoutId = setTimeout(() => {
                setClick(false)
            }, 1000);
            return () => clearTimeout(timeoutId);
        }
    }, [isClick]);
    
    return (
        <div className={`${styles.comment_data} position-relative`} class="post-category">
            <div className="w-100 d-flex flex-column flex-md-column justify-content-between">
                <div className={styles.avatar_container}>
                    <Avatar
                        with_ellipses={'with_ellipses'}
                        language={props.language}
                        id={props.item.user_details.id}
                        profession={translate_word(props.item.service_details, t("language_code"))}
                        hide_post={() => console.log('sfj')}
                        report_post={(text) => console.log('sfj')}
                        url={url}
                        username={props.item.user_details.username}
                        first_name={props.item.user_details.first_name}
                        last_name={props.item.user_details.last_name}
                        image={props.item.user_details.image}
                        service={translate_word(props.item.service_details, i18n.language)}
                        service_id={props.item.service_details?.id}
                        price={props?.item?.price}
                        free_day={props?.item?.free_day}
                        // hideOptions={true}
                        post_id={props.item.id}
                        zip_code={props?.item?.zip_code}
                        address={props?.item?.address?.substr(0, props?.item?.address?.lastIndexOf(","))}
                        city={props?.item?.city}
                    />
                </div>
                {/* <div onClick={() => router.push(`/${props.item.id}`)} className={styles.removeRedEyeIcon}><RemoveRedEyeIcon style={{ color: '#f9989c' }} /></div> */}
                <div className={styles.comments_images}>
                    <div className="posts-page-slider" {...longPressEvent}>
                        {isClick && <div className='animated_heart'>
                            <img src='/output-onlinegiftools.gif' />
                        </div>}
                        <div className={styles.img_count}>
                            {sliderCurrentId + 1} / {props.item.files.length}
                        </div>
                        <Slider {...settings}>
                            {props.item.files.map((item, index) => {
                                let myImg = document?.querySelector(`#img${index}`);
                                let realWidth = myImg?.naturalWidth;
                                let realHeight = myImg?.naturalHeight;
                                let windowWidth = window.innerWidth;
                                return index < 3 ?
                                    <div style={{
                                        width: '100%',
                                        height: realWidth > windowWidth && windowWidth < 480 && realWidth > realHeight ? windowWidth : '100%'
                                    }}>
                                        <div key={index} className={item.file_type === "image"
                                            ? styles.gallery_image_link
                                            : styles.gallery_video_link}>
                                            {props.item.files.length > 3 && index === 0
                                                ? <div className={styles.more_images}>+{props.item.files.length - 3}</div>
                                                : null}
                                            {item.file_type === "image"
                                                ? <LazyLoadImage
                                                    id={`img${index}`}
                                                    className={styles.gallery_image}
                                                    width={realWidth < windowWidth && windowWidth < 480 && props.item.files.length === 1 ? realWidth : '100%'}
                                                    height={realWidth < windowWidth && windowWidth < 480
                                                        ? realHeight
                                                        : props.item.files.length > 1 && windowWidth < 480 ? windowWidth : '100%'}
                                                    effect="blur"
                                                    alt="image"
                                                    src={item.file_url}
                                                    onClick={() => {
                                                        setProductIndex(index);
                                                        setToggler(!toggler);
                                                    }}
                                                />
                                                : <div className={styles.gallery_video}
                                                    onClick={() => {
                                                        setProductIndex(index + 1);
                                                        setToggler(!toggler);
                                                    }}><video controls muted autoPlay className={styles.post_frist_image}>
                                                        <source src={`${item?.file_url}#t=0.001`} type="video/mp4"></source>
                                                    </video>
                                                </div>}
                                        </div>
                                    </div>
                                    : null;
                            })}
                        </Slider>
                        <PostCommentSlider
                            order_count={props?.item?.order_count}
                            array={props?.item?.comments}
                        />
                       
                    </div>
                    {/* {toggler && <Lightbox
                        mainSrc={images[productIndex]}
                        nextSrc={images[(productIndex + 1) % images.length]}
                        prevSrc={images[(productIndex + images.length - 1) % images.length]}
                        onCloseRequest={() => setToggler(false)}
                        onMovePrevRequest={() => setProductIndex((productIndex + images.length - 1) % images.length)}
                        onMoveNextRequest={() => setProductIndex((productIndex + images.length + 1) % images.length)
                        }
                    />} */}
                </div>
            </div>
            <CommentsData
                        onClick={() => {
                            posts_like_dislike(props.item.like_count)
                        }}
                        like_dislike={like_dislike}
                        token={props.token}
                        id={props.item.id}
                        liked_by_me={props.item.liked_by_me}
                        like_count={likeCount ? likeCount : props.item.like_count}
                        comment_count={props.item?.comments?.length}
                        order_count={props?.item?.order_count}
                        seen_count={props.item.seen_count}
                        language={props.language}
                        />
        </div>
    );
}
export default MastersPost;
